(function () {
  function initAdvantagesBar(root) {
    var items = root.querySelectorAll('.cellfy-advantage-item');
    if (items.length < 2) return;

    var speed = parseInt(root.dataset.rotateSpeed, 10) || 4000;
    var current = 0;

    items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === 0);
    });

    setInterval(function () {
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, speed);
  }

  function init() {
    document.querySelectorAll('[data-cellfy-advantages]').forEach(function (root) {
      if (root.dataset.cellfyAdvantagesInit === 'true') return;
      root.dataset.cellfyAdvantagesInit = 'true';
      initAdvantagesBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();